import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import {
  CreateVacancyDto,
  UpdateVacancyDto,
  Vacancy,
  VacancyListResponse,
} from './VacancyControl.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

const REQUEST_PREFIX = 'vacancy';

export const vacancyControlService = {
  getList: (params: {
    q?: string;
    page?: number | string;
    sort?: string;
  }): Promise<AxiosResponse<VacancyListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`${REQUEST_PREFIX}/list`), {
      cancelToken: listRequest.token,
      params,
    });
  },

  create: (data: CreateVacancyDto): Promise<AxiosResponse<Vacancy>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}/create`), data);
  },

  update: (data: UpdateVacancyDto): Promise<AxiosResponse<Vacancy>> => {
    return axios.put(getEndpointBase(`${REQUEST_PREFIX}/${data.id}`), data);
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
